import { Icons } from "assets/icons";
import NoDataFound from "components/common/NoDataFound";
import { PaymentStatusBadge, StatusBadge } from "components/common/StatusBadge";
import DataTable from "components/common/table/DataTable";
import TableShimmer from "components/common/TableShimmer";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { getTransactions } from "store/slices/customersSlice";
import { PLAN_TYPES } from "utils/constants";
import { CurrencySymbol, formatUTCDate } from "utils/utils";

const Transactions = ({ id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { loading2, transactions } = useSelector((state) => state.Customers);
  const { noTransactions } = Icons || {};

  useEffect(() => {
    dispatch(getTransactions(id));
  }, []);

  const columns = useMemo(
    () => [
      {
        header: "Invoice Number",
        key: "invoiceNumber",
      },
      {
        header: "Amount",
        key: "amount",
        render: (value) => (
          <p className="price_symbol">
            <CurrencySymbol width="12" height="14" />
            {value}
          </p>
        ),
      },
      {
        header: "Plan Type",
        key: "planType",
        render: (value) =>
          PLAN_TYPES?.find((option) => option?.value === value)?.name || "-",
      },
      {
        header: "Payment Method",
        key: "paymentMethod",
      },
      {
        header: "Billing Cycle Start",
        key: "billingInfo",
        render: (value) => (
          <div className="ltr_text">
            {formatUTCDate(value?.billingCycleStart)}
          </div>
        ),
      },
      {
        header: "Billing Cycle End",
        key: "billingInfo",
        render: (value) => (
          <div className="ltr_text">
            {formatUTCDate(value?.billingCycleEnd)}
          </div>
        ),
      },
      {
        header: "Created Date",
        key: "createdAt",
        render: (value) => (
          <div className="ltr_text">{formatUTCDate(value)}</div>
        ),
      },
      {
        header: "Payment Status",
        key: "paymentStatus",
        render: (value) => <PaymentStatusBadge status={value} t={t} />,
      },
    ],
    [t]
  );

  return (
    <div>
      {loading2 && <TableShimmer rows={12} columns={8} />}

      {!loading2 && transactions?.length === 0 && (
        <NoDataFound title={t("No transactions found")} icon={noTransactions} />
      )}

      {!loading2 && transactions?.length > 0 && (
        <DataTable columns={columns} data={transactions} t={t} />
      )}
    </div>
  );
};

export default Transactions;
